import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { defineCustomElements } from '@amzn/DMWebUIComponents/dist/loader';
import { App } from './components/App';
import store from './store';
import './index.scss';

ReactDOM.render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>,
  document.getElementById('root')
);

defineCustomElements();
